import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'portals-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
	footerLinks = [
		{
			title: 'About',
			links: [
				{ name: 'Company', link: '/' },
				{ name: 'Support', link: '/' },
				{ name: 'Privacy Policy', link: '/' },
			],
		},
		{
			title: 'Visit',
			links: [
				{ name: '417 5th Avenue', link: '/' },
				{ name: 'Suite 814', link: '/' },
				{ name: 'New York, NY 10016', link: '/' },
			],
		},
		{
			title: 'Contact',
			links: [
				{ name: 'connect@jotto.me', link: '/' },
				{ name: '(718) 388-5063', link: '/' },
			],
		},
	];
	socialMedia = [
		{ id: 'social-media-1', icon: 'fab fa-instagram', link: 'https://www.instagram.com/jotto.video/' },
		{ id: 'social-media-2', icon: 'fab fa-facebook', link: 'https://www.facebook.com/jotto.connects' },
		// { id: 'social-media-3', icon: 'fab fa-twitter', link: 'https://www.twitter.com/' },
		{ id: 'social-media-4', icon: 'fab fa-linkedin', link: 'https://www.linkedin.com/company/jotto/' },
		// { imageUrl: '/assets/images/jotto-app-logo.png', link: '/' }, //  This is for when the jotto icon is put back 


	];

	isHovering: boolean[] = [];

	constructor(private router: Router) {
		this.isHovering = new Array(this.footerLinks.length).fill(false);
	}

	navigateToHome() {
		this.router.navigate(['/']);
	}
	navigateToCompany() {
		this.router.navigate(['/company']);
	}
	navigateToSupport() {
		this.router.navigate(['/support']);
	}
	onMouseEnter(index: number): void {
		this.isHovering[index] = true;
	}

	onMouseLeave(index: number): void {
		this.isHovering[index] = false;
	}

	openLink(url: string): void {
		if(url === '/'){
			this.navigateToHome()
			return
		}
		window.open(url, '_blank');
	}

	ngOnInit(): void {}
}
